import React from 'react';

const SearchField = props => (
  <div className="search-container">
    <form id="search" role="search" autoComplete="off">
      <div className="form-group search-control">
        <i className="icon-budicon-489 search-icon" />
        <input type="text" id="search-input" className="search-input form-control" {...props} />
      </div>
    </form>
  </div>
);

export default SearchField;



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/components/SearchField/SearchField.js